import { api } from '../index';

const prefix = '/api/promotion/';

export function apiIndex() {
	return api.get(prefix + 'index');
}

export function apiSelectPromotionList(param) {
	return api.post(prefix + 'selectPromotionList', param);
}

export function apiSelectPromotion(param) {
	return api.post(prefix + 'selectPromotion', param);
}

export function apiSelectPromotionClassList(param) {
	return api.post(prefix + 'selectPromotionClassList', param);
}

export function apiInsertPromotion(param) {
	param.mode = 'insert';
	return apiSubmitPromotion(param);
}

export function apiUpdatePromotion(param) {
	param.mode = 'update';
	//console.log(param);
	return apiSubmitPromotion(param);
	//return api.post(prefix + 'submitUser', param);
}

function apiSubmitPromotion(param) {
	return api.post(prefix + 'submitPromotion', param);
}

export function apiUpdatePromotionClasses(param) {
	return api.post(prefix + 'updatePromotionClasses', param);
}

export function apiSelectNotSoldPromotionList(param) {
	return api.post(prefix + 'selectNotSoldPromotionList', param);
}

export function apiSelectActivePromotionClassCodes(param) {
	return api.post(prefix + 'selectActivePromotionClassCodes', param);
}
